import { render, staticRenderFns } from "./DemoChurch.vue?vue&type=template&id=533416a1&"
import script from "./DemoChurch.vue?vue&type=script&lang=js&"
export * from "./DemoChurch.vue?vue&type=script&lang=js&"
import style0 from "./DemoChurch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports